import React from 'react';
import { useHistory } from 'react-router-dom';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/Products.css';

const Products = () => {
  const history = useHistory();
  useScrollAnimation();

  const products = [
    {
      id: 1,
      path: 'pig-farm',
      title: '스마트 돼지 농장 관리 시스템',
      description:
        'AI 기반 돼지 건강 모니터링 및 관리 시스템으로, 실시간 건강 상태 추적과 이상 징후 감지를 통해 농장의 생산성을 극대화합니다.',
      image: '/images/pig-farm.jpg',
    },
    {
      id: 2,
      path: 'wasp-system',
      title: 'AI 말벌 퇴치 시스템',
      description:
        '딥러닝 기반 말벌 감지 및 퇴치 솔루션으로, 정확한 말벌 감지와 자동 퇴치 기능을 통해 안전한 환경을 제공합니다.',
      image: '/images/wasp-system.jpg',
    },
    {
      id: 3,
      path: 'aas',
      title: 'AAS',
      description:
        'Asset Administration Shell 기반 산업용 데이터 관리 시스템으로, 센서 데이터를 표준화된 AASX 파일로 변환하고 효율적으로 관리합니다.',
      image: '/images/aas-dashboard.jpg',
    },
    {
      id: 4,
      path: 'ai',
      title: 'AI',
      description: '제트플로우는 다양한 AI 기술을 보유하고 있습니다.',
      image: '/images/ai-image.jpg',
    },
  ];

  return (
    <section className="products-section">
      <div className="products-container">
        <h2 className="section-title fade-in">서비스</h2>
        <div className="product-grid">
          {products.map((product) => (
            <div
              key={product.id}
              className={`product-card ${product.id === 1 ? 'slide-in-left' : 'slide-in-right'}`}
              onClick={() => history.push(`/products/${product.path}`)}
            >
              <div className="product-image">
                <img src={product.image} alt={product.title} />
              </div>
              <div className="product-content">
                <h3 className="product-title">{product.title}</h3>
                <p className="product-description">{product.description}</p>
                <button className="product-button">자세히 알아보기</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
